import { searchParametersActions } from 'features/searchResultsFacets';
import CheckboxGroup from '@components/checkbox';
import { store, store$ } from '@redux/store';
import { distinctUntilChanged, map } from 'rxjs';
import { communityAmenitiesSelector } from '../redux/selectors';

const select = document.querySelector('[data-amenities-group]');
const natureAreasElement = select.querySelector('[data-nature-areas]');
const poolElement = select.querySelector('[data-pool]');
const golfCourseElement = select.querySelector('[data-golf-couse]');
const greenElement = select.querySelector('[data-green]');
const sportFacilitiesElement = select.querySelector('[data-sport-facilities]');
const parksElement = select.querySelector('[data-parks]');
const viewsElement = select.querySelector('[data-views]');
const waterfrontElement = select.querySelector('[data-waterfront]');
const gatedCommunityElement = select.querySelector('[data-gated-community]');
const checkboxGroup = new CheckboxGroup(select);
const amenities$ = checkboxGroup.getObservable();
checkboxGroup.setSelector(communityAmenitiesSelector);

const setValue = (amenities) => {
  const { natureAreas, pool, golfCourse, green, sportsFacilities, parks, views, waterfront, gatedCommunity } =
    amenities;
  natureAreasElement.checked = natureAreas || false;
  poolElement.checked = pool || false;
  golfCourseElement.checked = golfCourse || false;
  greenElement.checked = green || false;
  sportFacilitiesElement.checked = sportsFacilities || false;
  parksElement.checked = parks || false;
  viewsElement.checked = views || false;
  waterfrontElement.checked = waterfront || false;
  gatedCommunityElement.checked = gatedCommunity || false;
};

amenities$.subscribe((amenities) => {
  const payload = {};

  amenities.forEach((amenity) => {
    payload[amenity] = true;
  });

  store.dispatch(searchParametersActions.fetchAmenities(payload));
});

store$.pipe(map(communityAmenitiesSelector), distinctUntilChanged()).subscribe(setValue);